
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      AppDialog,
    },
  })
  export default class ConfirmArchivePopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'car', dialogName: 'confirmArchive' };
    confirmCarLeaveParkFlag = false;

    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async confirm() {
      await this.payloadPopup.confirmAction();
      await this.onClose();
    }

    async closeAction() {
      this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
    }

    async onClose() {
      await this.closeAction();
      this.$refs.appDialog.onClose();
    }

  }
